import { render, staticRenderFns } from "./noticecomponent.vue?vue&type=template&id=2fea7796&scoped=true&"
import script from "./noticecomponent.vue?vue&type=script&lang=js&"
export * from "./noticecomponent.vue?vue&type=script&lang=js&"
import style0 from "./noticecomponent.vue?vue&type=style&index=0&id=2fea7796&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fea7796",
  null
  
)

export default component.exports